export default __webpack_public_path__ + "static/media/discounts-newbie-gift-image.340fd483.svg";